import { CHATBOT_IDENTIFIERS } from 'src/app/contexts/shared/constants/chatbot.constants';
import { MessageModal } from '../../../core/components/modal/message-modal';

export class ModalMessageFactory {
  forgotPassword(chatbotId: string): MessageModal {
    const descModal = chatbotId === CHATBOT_IDENTIFIERS.ADVISOR_AUTHENTICATION
      ? 'Recupérala desde tu Banca Móvil o llamando a Banca por teléfono al 311-9898. Tu asesor sigue esperándote en Whatsapp.'
      : 'Recupérala desde tu Banca Móvil o comunícate con nuestra Banca por Teléfono al 311-9898 y uno de nuestros asesores te ayudará.';

    const textBtnModal = chatbotId === CHATBOT_IDENTIFIERS.ADVISOR_AUTHENTICATION
      ? 'Regresar con mi asesor'
      : 'Entendido'
      
    return {
      titleModal: '¿Olvidaste tu Clave de Internet de 6 dígitos?',
      descModal,
      textBtnModal,
      actionBtnModal: ''
    };
  }

  createPassword(chatbotId: string): MessageModal {
    const descModal = chatbotId === CHATBOT_IDENTIFIERS.ADVISOR_AUTHENTICATION
      ? 'Al presionar "Entendido" te llevaremos a una página oficial del BCP para crear tu clave. Luego, regresa a Whatsapp y tu asesor continuará tu atención.'
      : 'Al presionar “Entendido” te llevaremos a una página oficial del BCP para crear tu clave. Luego, vuelve a escribirnos al WhatsApp del BCP para iniciar sesión.';

    return {
      titleModal: 'Crea tu Clave de Internet',
      descModal,
      textBtnModal: 'Entendido',
      actionBtnModal: 'redirectTo'
    };
  }

  lastAttemp(): MessageModal {
    return {
      titleModal: 'Último intento',
      descModal: 'La clave es incorrecta. Asegúrate de ponerla correctamente, de lo contrario, tu tarjeta será bloqueada.',
      textBtnModal: 'Entendido',
      actionBtnModal: ''
    };
  }

  attemp(): MessageModal {
    return {
      titleModal: 'La clave que ingresaste es incorrecta',
      descModal: 'Verifica tus datos y recuerda que superado el número máximo de intentos ya no podrás autenticarte con tu tarjeta durante el día.',
      textBtnModal: 'Entendido',
      actionBtnModal: ''
    };
  }
}
